export default "__VITE_ASSET__Ip81Lk79__"